import { render, staticRenderFns } from "./salesParams.vue?vue&type=template&id=3423c0f0&scoped=true&"
import script from "./salesParams.vue?vue&type=script&lang=js&"
export * from "./salesParams.vue?vue&type=script&lang=js&"
import style0 from "./salesParams.vue?vue&type=style&index=0&id=3423c0f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423c0f0",
  null
  
)

export default component.exports